import {useDispatch} from 'react-redux';
import Typography from '@mui/material/Typography';
import {Box, CircularProgress, Tooltip} from '@mui/material';
import StarRateIcon from '@mui/icons-material/StarRate';
import Command from '../../state/actions/command';
import {useEffect, useState} from 'react';
import Api from '../../api';

const VOTING_VERSION = '5';

const VotingPage = () => {
    const dispatch = useDispatch();
    const [voted, setVoted] = useState<boolean|undefined>(undefined);
    const [noCompanyFound, setNoCompanyFound] = useState<boolean>(false);
    const [selectedStar, setSelectedStar] = useState<number|null>(null);
    const [companyName, setCompanyName] = useState<string|null>(null);

    const companyId = window.location.pathname.split('/').pop();

    useEffect(() => {
        if (!companyId || companyId === 'vote') {
            setNoCompanyFound(true);
        } else {
            setVoted(localStorage.getItem('bg_voted_bl_' + VOTING_VERSION + '_' + companyId) === 'true');

            Api.Query.getCompanyName(companyId).then((data) => {
                if (data && data) {
                    setCompanyName(data);
                    setNoCompanyFound(false);
                } else {
                    setNoCompanyFound(true);
                }
            }).catch((reason) => {
                setNoCompanyFound(true);
            });
        }
    }, [companyId]);

    if (noCompanyFound) {
        return (
            <Typography variant={'h4'} sx={{textAlign: 'center', paddingTop: '100px'}}>
                <b>Brandenburger Lieblingslokal</b><br /><br />
                Dieses Unternehmen konnten wir nicht finden, da muss etwas schief gelaufen sein!
            </Typography>
        );
    }

    const handleVote = (vote: number) => {
        if (noCompanyFound || !companyId) {
            return;
        }
        setVoted(true);
        dispatch(Command.Company.addCompanyVote({companyId: companyId, vote: vote}));
        localStorage.setItem('bg_voted_bl_' + VOTING_VERSION + '_' + companyId, 'true');
    };

    return (
        <Box sx={{height: '100%', margin: 'auto'}}>
            <Typography variant={'h2'} sx={{paddingBottom: '50px', paddingTop: '50px', textAlign: 'center'}}>
                <b>Dein Brandenburger Lieblingslokal</b><br />
                Dir gefällt es hier, dann einfach abstimmen!<br />
                (1 - schlecht bis 5 - sehr gut)
            </Typography>
            { companyName && (
                <Typography variant={'h1'} sx={{paddingBottom: '50px', textAlign: 'center', fontWeight: 'bold'}}>
                    Restaurant: {companyName}
                </Typography>
            )}

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '20vh',
                    paddingBottom: '250px',
                }}
            >
                {(voted === false) && companyName && points.map((vote: number) => (
                    <Box
                        style={{padding: 1, cursor: 'pointer'}}
                        onClick={() => setSelectedStar(vote)}
                    >
                        <Tooltip title={`Bewerte ${companyName} mit ${vote} Sternen`} placement={'top'}>
                            <StarRateIcon
                                sx={{
                                    fontSize: {
                                        xs: '50px', // mobile
                                        sm: '100px', // tablet and up
                                    },
                                    color: selectedStar !== null
                                        ? (vote <= selectedStar ? '#ffcc00' : '#6e6e6e')
                                        : '#6e6e6e',
                                }}
                            />
                        </Tooltip>
                    </Box>
                ))}
                {(voted === false) && companyName && (
                    <Box sx={{width: '100%', textAlign: 'center', paddingTop: '40px'}}>
                        <Typography variant={'h2'}>
                            {selectedStar && `Du hast ${selectedStar} Sterne ausgewählt.`}&nbsp;
                            Klicke auf einen Stern, um deine Bewertung zu ändern.
                        </Typography>
                        <button
                            style={{
                                padding: '15px 30px',
                                fontSize: '16px',
                                marginTop: '20px',
                                cursor: selectedStar ? 'pointer' : 'default',
                                backgroundColor: selectedStar ? '#4caf50' : '#9e9e9e',
                                color: 'white',
                                borderRadius: '5px',
                                border: 'none',
                                fontSizeAdjust: '20px',
                            }}
                            disabled={selectedStar === null}
                            onClick={() => handleVote(selectedStar!)}
                        >
                            Meine Bewertung abgeben!
                        </button>
                    </Box>
                )}
                {(voted === true) && (
                    <Typography variant={'h2'} sx={{color: 'green'}}>
                        Vielen Dank für deine Stimme!
                    </Typography>
                )}
                {(voted === undefined) && (
                    <Typography variant={'h2'}>
                        <CircularProgress />
                    </Typography>
                )}

            </Box>
        </Box>
    );
};

const points: number[] = [1, 2, 3, 4, 5];

export default VotingPage;
